import { serverCall } from 'utils/serverCall';
import {
  initCompanyAdminListRequest,
  setCompanyAdminList,
  errorCompanyAdminList,
  initSingleAdminRequest,
  setSingleAdmin,
  errorSingleAdmin
} from './action';
import apiEndpoints from 'utils/apiList';

export const fetchCompanyAdminList = (newEnterpriseCompany) => {
  return async (dispatch) => {
    dispatch(initCompanyAdminListRequest());
    try {
      const result = await serverCall(`${apiEndpoints.COMPANY_ADMIN_GET_ALL}/${newEnterpriseCompany ?'1': '0'}`, 'GET', dispatch);
      if (result.success) {
        dispatch(setCompanyAdminList(result.data.payload));
      } else {
        dispatch(errorCompanyAdminList(result.message));
      }
    } catch (error) {
      dispatch(errorCompanyAdminList(error.message));
    }
  };
};

export const fetchSingleAdmin = (id) => {
  return async (dispatch) => {
    dispatch(initSingleAdminRequest(id));

    try {
      const result = await serverCall(`${apiEndpoints.COMPANY_ADMIN_GET_SINGLE}/${id}`, 'GET', dispatch);

      if (result.success) {
        dispatch(setSingleAdmin(result.data.payload));
      } else {
        dispatch(errorSingleAdmin(result.message));
      }
    } catch (error) {
      dispatch(errorSingleAdmin(error.message));
    }
  };
};
